import { render, staticRenderFns } from "./SelectKnowledgeAttachmentDialog.vue?vue&type=template&id=b1f65a88&"
import script from "./SelectKnowledgeAttachmentDialog.vue?vue&type=script&lang=js&"
export * from "./SelectKnowledgeAttachmentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports